import { useNavigate } from "react-router-dom";
import { PurchaseShell } from "../features/purchase/PurchaseShell";
import { SupplierForm } from "../features/purchase/SupplierForm";

// صفحة إضافة مورّد جديد.
export default function PurchaseNewSupplierPage() {
  const navigate = useNavigate();
  const back = () => navigate("/purchases/suppliers");

  return (
    <PurchaseShell titleKey="suppliers">
      <SupplierForm onDone={back} onCancel={back} />
    </PurchaseShell>
  );
}
